// MessageDialogPlugin.js
import MessageDialog2 from '@/components/MessageDialog2/index.vue'

const MessageDialogPlugin = {
  install(Vue, options) {
    // 注册全局方法
    Vue.prototype.$messageDialog = params => {
      // 创建一个 Vue 实例，用于显示对话框
      const dialogInstance = new Vue({
        render: h =>
          h(MessageDialog2, {
            props: {
              ...params,
              dialogVisible: true // 强制显示对话框
            },
            on: {
              onClose: () => {
                dialogInstance.$destroy()
                params.onClose && params.onClose()
              },
              onClickLeftBtn: () => {
                dialogInstance.$destroy()
                params.onClickLeftBtn && params.onClickLeftBtn()
              },
              onClickRightBtn: () => {
                dialogInstance.$destroy()
                params.onClickRightBtn && params.onClickRightBtn()
              }
            }
          })
      })

      // 将对话框实例挂载到 body 上
      const vm = dialogInstance.$mount()
      document.body.appendChild(vm.$el)

      return dialogInstance
    }
  }
}

export default MessageDialogPlugin
